import { DateTime } from "luxon";
import { setActivePinia } from 'pinia';

import { useFavouritesStore } from "../vue/store/index";
import { pinia } from "./vueComponents";

const localStorageKey = "application-reset-all";

let handler = () => {
  resetLocalStorage();
};

function init() {
  // Set up a listener to watch for changes in other browser tabs.
  window.addEventListener(
    "storage",
    (event) => {
      if (event.key !== localStorageKey) {
        return;
      }
      handler(() => {});
    },
    false
  );
}

/**
 * Note this removes all the application types.
 * application.js resetLocalStorage() removes only the current type application data.
 */
function resetLocalStorage() {
  // Set active pinia instance to use store outside Vue components
  setActivePinia(pinia);
  const store = useFavouritesStore();
  store.emptyFavourites();
  store.removeLocalSave({ type: "right-of-occupancy" });
  store.removeLocalSave({ type: "owner-occupancy" });
  store.removeLocalSave({ type: "rental" });
}

function resetAll() {
  handler(resetLocalStorage);

  // Just set *something* to localstorage to trigger change in other browser tabs.
  localStorage.setItem(localStorageKey, DateTime.local().toISO());
}

/**
 * Handler is a callback function that is called on all browser tabs when a "resetAll event" occurs. The handler gets a
 * function as a parameter that must be called in to reset local storage. On other tabs (where the "event" *didn't*
 * originate from) the passed function doesn't do anything -> it will only run once across all tabs.
 *
 * @param newHandler
 */
function setHandler(newHandler) {
  handler = newHandler;
}

export default {
  init,
  resetAll,
  setHandler,
};
